<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader label="Поздравляем!" hide-back-button />
        <div class="q-pa-md base-page-content" style="padding-top: 50px">
            <div class="q-gutter-y-lg" style="margin-bottom: 0" v-show="!loading">
                <div>
                    <div>Вы купили</div>
                    <div class="text-weight-bold ellipsis-3-lines">{{ title }}</div>
                </div>
                <div>
                    {{ params.hint }}
                </div>
                <div class="q-gutter-sm">
                    <DefaultButton label="Готово" @click="close" />
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import DefaultButton from 'components/ui/common/DefaultButton';

export default {
    name: 'PageBuySuccess',
    components: { DefaultButton, SotHeader, BasePage },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            loading: false,
            balance: 0,
        };
    },
    computed: {
        productId () {
            return this.params.product_id;
        },
        productType () {
            return +this.params.product_type;
        },
        title () {
            return this.params.title;
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            /*
            this.loading = true;
            this.$db.tasks.getCoursePrices(this.courseId).then((prices) => {
                if (prices) {
                    this.price = +prices.price_personal;
                    this.discount = +prices.discount_personal;
                }
                this.$db.users.getMyBalance().then((balance) => {
                    this.balance = balance.replaceAll('.00', '');
                    this.loading = false;
                });
            });
             */
        },
        close () {
            this.$pages.backToRoot();
            // Курс
            if (this.productType === 1) {
                this.$pages.push({
                    to: 'course_page',
                    course_id: this.productId,
                    label: this.title,
                });
            }
            // Подписка
            if (this.productType === 2) {
                this.$pages.push({
                    to: 'subscription_page',
                    subscription_id: this.productId,
                    label: this.title,
                });
            }
        },
    },
};
</script>

<style scoped>

</style>
